/**
 * 📂 File: src/app/student-animation-showcase/helpers/event.ts
 * 🧭 Description:
 * Helper functions for locating Student Animation Showcase events.
 */

import type { PremierBlock } from '../types';

/* -------------------------------------------------- */
/* 🎬 Get Event By Year                               */
/* -------------------------------------------------- */

export function getEventByYear(
  events: PremierBlock[],
  year: number,
): PremierBlock | null {
  return (
    events.find((event) => {
      const title = event.title.toLowerCase();

      return (
        title.includes(String(year)) || event.premierDate.startsWith(`${year}-`)
      );
    }) ?? null
  );
}
